var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('el-button', _vm._b({ on: { "click": _vm.handleClick } }, 'el-button', _vm.buttonAttrs, false), [_c('svg-icon', { attrs: { "icon-class": "publish" } }), _vm._v("\n  " + _vm._s(_vm.buttonAttrs.text) + "\n")], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };